import React, { useState } from 'react';
import styled from '@emotion/styled';
import Input from 'views/ui/form_elements/input';
import TextSelect from 'ui_system/select/TextSelect';
import Dimmer from 'views/shared/ui/dimmer';
import { useIntl, FormattedMessage } from 'react-intl';
import { translateUnitNoun } from 'services/translation/unitNounMessages';
import GuestNameInput from 'views/plugins/checkout/guest_name_input/GuestNameInput';
import { brandNeutralColors } from 'ui_system/compass/utils';
import { formatTicketTypes, calculateRemainingTickets } from './Helpers';

const DisabledInput = styled(Input)`
  border: 1px ${brandNeutralColors.borderAction};
  background-color: #f2f2f2 !important;
  color: #333;
`;

const GuestInformationContainer = ({
  bookerGuestName,
  units,
  unitsLoaded,
  onChange,
  stepNo,
  lastSection,
  brandColor,
}) => {
  if (!unitsLoaded) {
    return <Dimmer fixed transparent loader active />;
  }

  return (
    <GuestInformation
      bookerGuestName={bookerGuestName}
      units={units}
      onChange={onChange}
      stepNo={stepNo}
      lastSection={lastSection}
      brandColor={brandColor}
    />
  );
};

const GuestInformation = ({
  bookerGuestName,
  units,
  onChange,
  stepNo,
  lastSection,
  brandColor,
}) => {
  const intl = useIntl();
  const unitsSelectOptions = formatTicketTypes(units);
  const translatedUnitsSelectOptions = unitsSelectOptions.map((option) => ({
    ...option,
    label: translateUnitNoun(intl, option.label),
  }));

  // rename Ticket to Unit ?
  const initialSelectedTicket = unitsSelectOptions[0].value;
  const [selectedTicket, setSelectedTicket] = useState(initialSelectedTicket);

  function onSelected(value) {
    setSelectedTicket(value);
    onChange(
      'bookerUnitId',
      units.find((u) => u.noun_singular.toLowerCase() === value.toLowerCase())
        .id
    );
  }

  let displayBookerGuestName;
  if (bookerGuestName !== '' && bookerGuestName !== ' ') {
    displayBookerGuestName = bookerGuestName;
  }

  // Remove selected ticket from array
  const remainingTickets = calculateRemainingTickets(units, selectedTicket);
  const hasMultipleUnits = unitsSelectOptions && unitsSelectOptions.length > 1;

  return (
    <div
      className="CheckoutSection CheckoutGuestInformation"
      data-testid="guest-of-guest-section"
      style={{ borderBottom: lastSection ? '1px solid #e6e6e6' : null }}
    >
      <h2>
        <span className="step">{stepNo}</span>
        <FormattedMessage
          id="GUEST_INFORMATION"
          defaultMessage="Guest Information"
        />
      </h2>
      <div>
        <div className="ticket-select">
          <span className="ticket-select-label">
            <FormattedMessage
              id="GUEST_NUMBER"
              defaultMessage="Guest {number}"
              values={{ number: 1 }}
            />
          </span>
          <TextSelect
            className="ticket-select-box"
            selectedLabel={translateUnitNoun(intl, selectedTicket)}
            selectedValue={translateUnitNoun(intl, selectedTicket)}
            onSelectItem={onSelected}
            items={translatedUnitsSelectOptions}
            brandColor={brandColor}
            unitsSelectOptions={translatedUnitsSelectOptions}
            customDropdown
            dataTestId="ticket-label-select"
          />
        </div>
        <div className="row" data-testid="booking-guest-name-input">
          <DisabledInput
            name="Guest 1"
            placeholder={intl.formatMessage({
              id: 'YOU',
              defaultMessage: 'You',
            })}
            maxLength="150"
            disabled
            value={displayBookerGuestName}
          />
        </div>
      </div>
      <div>
        {remainingTickets.map(({ unitTypeId, unitTypeName }, index) => (
          <GuestNameInput
            key={index}
            index={index}
            selectedTicket={selectedTicket}
            onChange={onChange}
            unitTypeId={unitTypeId}
            unitTypeName={translateUnitNoun(intl, unitTypeName)}
            hasMultipleUnits={hasMultipleUnits}
            dataTestId="additional-guest-name-input"
          />
        ))}
      </div>
    </div>
  );
};

export default GuestInformationContainer;
